<template>
  <div class="x-cars-logo">
    <svg 
      :width="width" 
      :height="height" 
      viewBox="0 0 200 60" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      class="logo-svg"
    >
      <!-- Background gradient -->
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style="stop-color:#00d4ff;stop-opacity:1" />
          <stop offset="50%" style="stop-color:#5b21b6;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#ec4899;stop-opacity:1" />
        </linearGradient>
      </defs>
      
      <!-- Text "X CARS" -->
      <text 
        x="90" 
        y="25" 
        font-family="Arial, sans-serif" 
        font-size="18" 
        font-weight="bold" 
        fill="white"
      >
        X
      </text>
      <text 
        x="110" 
        y="25" 
        font-family="Arial, sans-serif" 
        font-size="18" 
        font-weight="bold" 
        fill="white"
      >
        CARS
      </text>
      
      <!-- Subtitle -->
      <text 
        x="90" 
        y="40" 
        font-family="Arial, sans-serif" 
        font-size="8" 
        fill="#6b7280"
      >
        Your first dream NFT on X Layer
      </text>
    </svg>
  </div>
</template>

<script setup lang="ts">
interface Props {
  width?: string | number
  height?: string | number
}

withDefaults(defineProps<Props>(), {
  width: 200,
  height: 60
})
</script>

<style scoped>
.x-cars-logo {
  display: inline-block;
}

.logo-svg {
  transition: transform 0.3s ease;
}

.logo-svg:hover {
  transform: scale(1.05);
}
</style>